"use strict";

/**
 * @description Adds a Zendesk button clone on PDP(mobile) in order to assure the desired styling and not overlap other elements
*/
const zendeskCloneInit = () => {
    const $zendeskCloneButton = $(".js-zendesk-widget");

    if (window.mqRespond.status.lgDown && $zendeskCloneButton.length && window.zE) {
        zE(() => { // eslint-disable-line
            zE.hide(); // eslint-disable-line
            $zendeskCloneButton.removeClass("d-none");
        });

        $zendeskCloneButton.on("click", () => {
            $zendeskCloneButton.fadeOut(500);
            zE.activate({hideOnClose: true}); // eslint-disable-line
        });

        zE("webWidget:on", "close", () => { // eslint-disable-line
            $zendeskCloneButton.fadeIn(500);
        });
    }
};

module.exports = zendeskCloneInit;
